<template>
  <div class="container">
    <div class="wick-guide">
      <div :class="interactive_guide_css_classes">
        <interactive-guide />
      </div>

      <div :class="table_css_classes">
        <container-and-pillar-table-guide />
      </div>

      <div class="info-toggle">
        <button class="btn btn-default toggle-btn" @click="toggleDisplay">
          {{ toggle_text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import InteractiveGuide from './wick-guide/interactive-guide.vue';
  import ContainerAndPillarTableGuide from './wick-guide/container-and-pillar-table-guide.vue';

  export default {
    components: {
      InteractiveGuide,
      ContainerAndPillarTableGuide
    },
    data() {
      return {
        interactiveVisible: true
      }
    },
    computed: {
      interactive_guide_css_classes() {
        const baseClass = 'interactive-guide';
        return this.interactiveVisible ? baseClass : `${baseClass} hidden`;
      },
      table_css_classes() {
        const baseClass = 'table-guide';
        return this.interactiveVisible ? `${baseClass} hidden` : baseClass;
      },
      toggle_text() {
        return this.interactiveVisible ? 'Show All Wick Suggestions' : 'Collapse Guide';
      }
    },
    methods: {
      toggleDisplay() {
        this.interactiveVisible = !this.interactiveVisible;
      }
    }
  }
</script>
